<template>
  <div>
    <form-field-input
      label="Label"
      v-model="form.label"
      :validation-errors="validationErrors.label"
    />

    <div class="flex flex-between mt-100">
      <div class="flex flex-vertical">
        <form-field-switch
          label="Creates Lead"
          v-model="form.creates_records"
          :validation-errors="validationErrors.creates_records"
          class="mb-0"
        />

        <p class="help is-black mt-25">If off no leads or comm logs will be created.</p>
      </div>

      <button-outlined
        class="ml-100"
        color="is-danger"
        @click="deleteSpamRecords"
        :loading="isDeletingSpam"
      >Delete Spam
      </button-outlined>
    </div>

    <hr>

    <h2 class="mb-100 has-text-weight-bold">Defaults for New Leads</h2>

    <form-field-select-campaign
      label="Campaign"
      v-model="form.campaign_id"
      :validation-errors="validationErrors.campaign_id"
    />

    <form-field-select-users
      label="User"
      v-model="form.user_id"
      :validation-errors="validationErrors.user_id"
    />

    <form-field-select-status
      label="Status"
      v-model="form.status_id"
      :validation-errors="validationErrors.status_id"
      :required="true"
    />

    <form-field-select-temperature
      label="Temperature"
      v-model="form.temperature"
      :validation-errors="validationErrors.temperature"
    />
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";
import {ENUMS} from "../services/enums";
import dates from "../services/dates";

export default {
  name: "IntegrationPhoneNumberForm",
  props: ["formData"],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        label: "",
        number: "",
        creates_records: false,
        campaign_id: null,
        user_id: null,
        status_id: this.$store.getters["pipeline/statuses"][0].id,
        temperature: ENUMS.TemperatureEnum.None.value,
      },
      isDeletingSpam: false,
    };
  },
  created() {
    this.form = (this.formData) ? this.$utils.clone({...this.defaultForm, ...this.formData}) : this.$utils.clone(this.defaultForm);
  },
  computed: {
    integration() {
      return this.$store.getters.integrations.find(i => i.id === this.formData.integration_id);
    },
    activeCampaigns() {
      return [
        {id: null, label: "None"},
        ...this.$store.getters.activeCampaigns,
      ];
    },
    status() {
      return this.$store.getters["pipeline/statuses"].find(status => status.id === this.form.status_id);
    }
  },
  methods: {
    update() {
      return this.$api.integrationPhoneNumbers.update(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: "Number was updated",
            type: "is-success"
          });

          return res;
        });
    },
    deleteSpamRecords() {
      const vm = this;
      const number = this.form;

      /**
       * TODO pipeline-overhaul probably tweak the message about New Status and pass status_id
       */
      this.$buefy.dialog.confirm({
        title: "Delete Spam Records",
        message: `This will <strong>permanently delete leads</strong> created by ${this.form.label} and still in the ${this.status.label} Status.<br><br><strong>We can not retrieve them</strong>.<br><br>Please make sure all legitimate leads are taken out of <strong>${this.status.label} Status</strong> before hitting this button, or they will be deleted.`,
        confirmText: "Delete Spam Records",
        type: "is-danger",
        hasIcon: true,
        onConfirm() {
          vm.isDeletingSpam = true;

          vm.$api.records.deleteSpamRecords({
            spam_source: number,
            status_id: number.status_id,
          }).then(() => {
            vm.$buefy.toast.open({message: "Spam records have been deleted", type: "is-success"});
          }).finally(() => {
            vm.isDeletingSpam = false;
          });
        }
      });
    },
  },
};
</script>
